export default __webpack_public_path__ + "static/media/thabit.305c29b1.svg";